import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import { updateCrumbs } from 'b2b-apps/shop/breadcrumbs/redux/actionCreators';
import { getCrumbs } from 'b2b-apps/shop/breadcrumbs/redux/selectors';
import { CrumbType } from 'b2b-apps/shop/breadcrumbs/redux/types';

const useBreadcrumbs = (breadcrumbs: CrumbType[]): void => {
  const dispatch = useDispatch();
  const current = useSelector(getCrumbs, isEqual);

  const updateBreadcrumbs = useCallback(
    (crumbs: CrumbType[]): void => {
      if (!isEqual(current, crumbs)) {
        dispatch(updateCrumbs(crumbs));
      }
    },
    [current, dispatch],
  );

  useEffect(
    (): void => {
      updateBreadcrumbs(breadcrumbs);
    },
    [breadcrumbs, updateBreadcrumbs],
  );
};

export { useBreadcrumbs };
